<script>
import Physicals from "./Physicals/Index";
import Legals from "./Legals/Index";

import { mapState, mapActions } from "vuex";

export default {
  title: "Clientes",

  components: {
    Physicals,
    Legals
  },

  computed: {
    ...mapState("clients", ["type"])
  },

  methods: {
    ...mapActions("clients", ["setType"])
  }
};
</script>

<template>
  <div class="box">
    <div class="title">CLIENTES</div>

    <div class="switch-group mb-20">
      <div
        class="switch"
        :class="{ active: type === 'legals' }"
        @click="setType('legals')"
      >
        B2B
      </div>
      <div
        class="switch"
        :class="{ active: type === 'physicals' }"
        @click="setType('physicals')"
      >
        B2C
      </div>
    </div>

    <physicals v-if="type === 'physicals'" />
    <legals v-else />
  </div>
</template>

<style scoped>
.switch-group {
  display: flex;
  flex-direction: row;
}
.switch {
  background: #efefef;
  color: #999;
  padding: 10px 15px;
  cursor: pointer;
  transition: all 0.24s ease;
  font-size: 12px;
}

.switch:first-child {
  border-radius: 4px 0 0 4px;
}

.switch:last-child {
  border-radius: 0 4px 4px 0;
}

.switch.active {
  background: var(--purple);
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Customers/Index.vue